/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import BASELoading from "../BASELoading";
import PropTypes from "prop-types";
import { Suspense } from "react";

/**
 * React Suspense defaults
 * For to Avoid Repetition
 */ function BASESuspense(props) {
  const { children, loadingProps = { delay: 0 } } = props;
  return (
    <Suspense fallback={<BASELoading {...loadingProps} />}>
      {children}
    </Suspense>
  );
}

BASESuspense.propTypes = {
  loadingProps: PropTypes.object,
};

// BASESuspense.defaultProps = {
//   loadingProps: {
//     delay: 0,
//   },
// };

export default BASESuspense;
